// Identificativo evento atteso da GET /app/get-events: "<eventName> || <when>" (spazi singoli, when verbatim)
export const toEventString = (event) => `${event.eventName} || ${event.when}`;

export const parseEventString = (eventString) => {
  const [eventName = '', when = ''] = eventString.split('||');
  return { eventName: eventName.trim(), when: when.trim() };
};

export const displayEventName = (eventName) => (eventName || '').replace('Ceramichine @', '');

// Solo percorsi interni dell'area admin come destinazione del tasto indietro
export const safeBackTarget = (back) => (back && back.startsWith('/admin/') ? back : '/admin/dashboard');

export const isPrivateEvent = (event) => event && event.eventType === 'private';

// Iscritti a un evento: biglietti HubSpot per i pubblici, "N° persone" per i privati. null = non disponibile
export const eventAttendees = (event, ticketCounts) => {
  if (isPrivateEvent(event)) {
    return typeof event.participants === 'number' ? event.participants : null;
  }
  if (!ticketCounts) return null;
  return ticketCounts[event.eventKey] || 0;
};

export const attendeesLabel = (n) => (n === null ? null : `${n} ${n === 1 ? 'iscritto' : 'iscritti'}`);

export const sumAttendees = (events, ticketCounts) =>
  events.reduce((sum, e) => sum + (eventAttendees(e, ticketCounts) || 0), 0);

// Filtro tipologia nelle liste: valore del parametro URL `type`
export const TYPE_FILTERS = [
  { value: 'all', label: 'Tutti' },
  { value: 'public', label: 'Pubblici' },
  { value: 'private', label: 'Privati' },
];
export const normalizeTypeFilter = (value) => (TYPE_FILTERS.some((f) => f.value === value) ? value : 'all');
export const filterEventsByType = (events, type) =>
  type === 'all' ? events : events.filter((e) => (e.eventType || 'public') === type);

export const eventTypeLabel = (event) => (isPrivateEvent(event) ? 'Privato' : 'Pubblico');

// Sottotitolo della card evento: solo data e ora
export const eventCardSubtitle = (event, formattedDate) => formattedDate;

// Pagina di dettaglio: gli eventi privati non hanno biglietti su HubSpot e usano una vista informativa dedicata
export const eventDetailPath = (event, { back, readOnly = false } = {}) => {
  const params = new URLSearchParams();
  if (isPrivateEvent(event)) {
    params.set('eventKey', event.eventKey);
  } else {
    params.set('event', toEventString(event));
  }
  if (readOnly) params.set('readonly', '1');
  if (back) params.set('back', back);
  return `${isPrivateEvent(event) ? '/admin/private-event' : '/admin/event'}?${params.toString()}`;
};
